function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
  d: "M47 59H13a2 2 0 01-2-2V24.18a3 3 0 01.8-2L28.64 9.26a2 2 0 012.72 0L48.2 22.14a3 3 0 01.8 2V57a2 2 0 01-2 2z",
  fill: "#a6aecc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 59h34a2 2 0 002-2V24.18a3 3 0 00-.8-2l-3.33-2.55L11 50.44V57a2 2 0 002 2z",
  fill: "#9a91c6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "30",
  cy: "19",
  r: "5",
  fill: "#f3f3f4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15",
  y: "33",
  width: "30",
  height: "22",
  rx: "2",
  ry: "2",
  fill: "#e3e9ec"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["cls-5"] || "cls-5",
  d: "M23 42h14v3H23zM23 47h14v3H23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 20a2 2 0 002-2V7a6 6 0 00-6-6h-5a2 2 0 00-2 2 2 2 0 002 2h5a2 2 0 012 2v11a2 2 0 002 2z",
  fill: "#55617f"
}));